<script setup>
const { page } = defineProps({
    page: {
        type: Object,
        required: true,
    },
});

const button = {
    label: 'All Blog Posts',
    url: '/blog'
}

const cta_image = {
    url: 'https://cdn.builder.io/api/v1/image/assets%2Fd09cfff8ac614d8a86e457a0274fa171%2Fa7cf2852e8964de59ee3d935993a8360',
    alt: 'An image showing friendly, happy people at the Inbound conference.'
}

const cta_button = {
    url: '/register',
    label: 'Register Now'
}

</script>
<template>
    <div class="blog-footer">
        <div class="root-container">
            <BlogAuthor :page="page" />
        </div>
        <globalBackToTop></globalBackToTop>
        <div class="related-posts-footer">
            <BlogThreeUp v-if="page" :page="page" headline="Related Blog Posts" :button=button />
            <ImageTextCta 
                headline="Your Growth Moment is Here" 
                copy="San Francisco is calling. Join fellow change-makers for three high-impact days of powerful insights and real connections. Leave with proven tactics and strategies that drive results." 
                :image="cta_image"
                :button="cta_button" />
        </div>
    </div>
</template>

<style lang="scss">
.blog-footer {
    .related-posts-footer {
        background-color: #fff;
    }
    .blog-author {
        margin-bottom: 4.5625rem;
    }
    .back-to-top {
        margin-bottom: 2.3125rem;
    }
}
</style>
